module.exports = __webpack_public_path__ + "static/media/ipad-5.dbf87fb9.jpg";